import React from 'react';
import './HeroMessage.css'



const HeroMessage = ()  => {


    return (
    <div className="hero-message-container">
        <h4 className="sub-slogan  "> Our Favorite Resources  </h4>
       <h1 className="slogan  animate__animated animate__fadeIn"> Search and Use our favorite resources to stay <em class="brilliance">BRILLIANT</em></h1>
    </div>
    )



}







export default HeroMessage;